import { ESCycle } from '~src/interfaces/cycle.interface';
import { ScheduleI } from '~src/interfaces/schedule.interface';
import { SurveySubjectTypes } from '~src/interfaces/surveys.interfaces';
import { Survey } from '~src/modules/surveys/interfaces';

interface AllAnalysisSpiderParams {
  surveySubjectType: SurveySubjectTypes;
  survey: string;
  topic: string;
  question: string;
  aboutSegments: string[];
  askSegments: string[];
  cycles: string[];
  isSelfAssessmentIncluded: boolean;
  // spidergraph form-step which is active right now
  activeStepIndex: number;
}

export type AnalysisSpiderParams = Partial<AllAnalysisSpiderParams>;

export class RichCycle {
  static getMostRecentCycle(richCycles: RichCycle[]): RichCycle | undefined {
    if (!richCycles.length) {
      return;
    }

    return richCycles.reduce((prev, cur) => (prev && prev.isMoreRecentThan(cur) ? prev : cur));
  }

  constructor(
    readonly cycle: ESCycle,
    readonly schedule: ScheduleI,
    readonly survey: Survey
  ) {}

  getId(): string {
    return this.cycle.id;
  }

  isMoreRecentThan(other: RichCycle): boolean {
    return this.cycle.start_date > other.cycle.start_date;
  }
}
